import styled from 'styled-components'

export const ProductsRecommendationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  max-width: 100%;
  p {
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
    color: ${props => props.theme.colors.black};
    margin: 0;
  }
`
